<template>
	<div id="livePreview">
		<swiper ref="mySwiper" :options="swiperOptions">
			<swiper-slide v-for="(item,index) in liveVideoList" :key="index">
				<div class="preview-item" @click="getLiveDetail(item)">
					<div class="time_line">
						<ul>
							<li :class="index == 0 ? 'time': 'other_time'">{{ item.lvrtStartTime }}</li>
							<!-- <li class="line" v-if="index != liveVideoList.length-1"></li> -->
							<li class="line"></li>
						</ul>
					</div>
					<div class="live_box">
						<ul>
							<li class="box_top">
								<img :src="item.lvrImgLargeUrl" alt="" v-if="item.lvrImgLargeUrl">
								<img :src="item.lvrRecommendImg" alt="" v-else-if="item.lvrRecommendImg">
								<img src="../../assets/img/live/no_play.png" alt="" v-else>
							</li>
							<li class="box_bottom">
								{{ item.lvrName }}
							</li>
						</ul>
					</div>
				</div>
			</swiper-slide>
			<swiper-slide v-if="swiperOptions.slidesPerView - (liveVideoList.length%swiperOptions.slidesPerView) > 0" v-for="(item,index,kk) in Math.abs(swiperOptions.slidesPerView - (liveVideoList.length%swiperOptions.slidesPerView))" :key="kk">
				<div class="preview-item">
					<div class="time_line">
						<ul>
							<li class="other_time">待定</li>
							<li class="line" v-if="index != Math.abs(swiperOptions.slidesPerView - (liveVideoList.length%swiperOptions.slidesPerView))-1"></li>
						</ul>
					</div>
					<div class="live_box">
						<ul>
							<li class="box_top">
								<img src="../../assets/img/live/no_play.png" alt="">
							</li>
							<li class="box_bottom">
								暂无安排
							</li>
						</ul>
					</div>
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
  export default {
	name:'livePreview',
    data() {
      return {
		  swiperOptions: {
		  	slidesPerView: 4,//显示个数
		  	direction: 'horizontal',
		  	loop: false, // 循环模式选项
		  	//分页
		  	pagination: {
		  		 el: ".swiper-pagination",
		  		 type: 'bullets',
		  		 clickable: true,
		  		 dynamicBullets: false
		  	},
		  	// 如果需要前进后退按钮
		  	navigation: {
		  		nextEl: '.swiper-button-next',
		  		prevEl: '.swiper-button-prev',
		  	},
		  	
		  	speed: 1000,
		  	// autoplay: {
		  	// 	 delay: 2000,
		  	// 	 disableOnInteraction: false
		  	// },
			effect:'slide',
		  },
      };
    },
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper
		}
	},
	props:{
		liveVideoList: {
			type:Array,
		}
	},
	mounted() {
		// this.swiper.slideTo(4, 1000, false);
	},
	watch: {
		liveVideoList: function(newValue) {
			// console.log(newValue);  //可以看到数据已经拿到
		}
	},
	methods:{
		getLiveDetail(item){
			this.$router.push({name:'liveDetail',query:{room_id:item.lvrId}});
		},
	}
  };
</script>

<style scoped>
	#livePreview{
		display: flex;
		justify-content: space-around;
	}
	
	.preview-item{
		width: 300px;
		height: 300px;
	}
	
	.preview-item .time_line{
		height: 33px;
		position: relative;
		margin-bottom: 15px;
	}
	
	.time_line .time{
		width: 86px;
		height: 33px;
		margin: 0 auto;
		background: #C60B09;
		border-radius: 0%;
		text-align: center;
		display: flex;
		justify-content: center;
		flex-direction: column;
		z-index: 2;
		color: #FFFFFFFF;
	}
	
	.time_line .other_time{
		width: 86px;
		height: 33px;
		margin: 0 auto;
		background: #D9D9D9;
		border-radius: 0%;
		text-align: center;
		display: flex;
		justify-content: center;
		flex-direction: column;
		z-index: 2;
		color: #222222;
	}
	
	.time_line .line{
		width: 248px;
		height: 2px;
		bottom: 16px;
		position: absolute;
		border-color: inherit;
		background-color: #e4e5e7;
		position: absolute;
		left: 193px;
	}
	
	.preview-item .live_box{
		height: 240px;
		background: #FFFFFF;
		border-radius: 20px;
		cursor: pointer;
	}
	
	.live_box .box_top img{
		width: 100%;
		height: 160px;
		margin-bottom: 10px;
		border-radius: 8px;
	}
	
	.live_box .box_bottom{
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 33px;
		margin-bottom: 21px;
		display: -webkit-box;
		overflow: hidden;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		text-align: center;
	}
	
	.live_time{
		min-height: 15%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		margin-bottom: 0.625rem;
	}
	.pre_time_box{
		width: 30%;
		height: 1.25rem;
		/* margin: 0 2.25rem; */
		display: flex;
		justify-content: center;
		top:20px
	}
	
	
	.live_content{
		text-align: center;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}
	
	.preview_box{
		width: 30%;
		height: 30%;
		background: #FFFFFF;
		margin: 0 2.25rem;
	}
	
	.pre_time{
		width: 25%;
		height: 1.25rem;
		text-align: center;
		border-radius: 50%;
		background-color: #C60B09;
		color: #FFFFFF;
		
		position: relative;
		z-index: 1;
	}
	.pre_time_line{
		height: 2px;
		top: 30%;
		left: 10%;
		right: 10%;
		position: absolute;
		border-color: inherit;
		background-color: #C0C4CC;
	}
	
	.pre_img{
		width: 70%;
		
		margin: 0 auto;
	}
	
	.pre_img img{
		width: 100%;
		margin-bottom: 0.625rem;
		margin-top: 0.9375rem;
	}
	
	
	.pre_context{
		font-size: 1.5rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
	}
	
	ul{
		margin: 0;
		padding: 0;
		list-style: none;
	}
	
	.swiper-slide{
		min-width: 302.5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/live_preview.vue